
import * as React from 'react';
import { Dialog, DialogFooter, IDialogProps } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, IButton } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';

/**
 * @internal
 */
export type IWarningDialogProps = {
  title: string;
  prompt: React.ReactNode;
  cancelText: React.ReactNode;
  onCancel: () => void;
} & Pick<IDialogProps, 'maxWidth'>;

/**
 * @internal
 */
export const WarningDialog: React.StatelessComponent<IWarningDialogProps> = (props: IWarningDialogProps) => {
  const {
    title,
    prompt,
    cancelText,
    onCancel
  } = props;

  const onCancelRef = (button: IButton | null) => {
    if (button) {
      button.focus();
    }
  };

  return (
    <Dialog
      onDismiss={ onCancel }
      isOpen={ true }
      title={ title }
      maxWidth={ props.maxWidth }
    >
      <Label>{ prompt }</Label>
      <DialogFooter>
        <PrimaryButton
          onClick={ onCancel }
          componentRef={ onCancelRef }
        >
          { cancelText }
        </PrimaryButton>
      </DialogFooter>
    </Dialog>
  );
};
